module.exports = __webpack_public_path__ + "static/img/Find.248e5b39.png";